// src/components/spatial/components/DrawToolbar.jsx

import React from "react";
import theme from "../../../styles/theme";
import drawSpaceConfig from "../config/drawSpaceConfig";

const DrawToolbar = ({
  tool,
  setTool,
  zoomIn,
  zoomOut,
  resetView,
  onPrint,
  enablePrint = true,

  gridSize,
  setGridSize,
  snapToGrid,
  setSnapToGrid,

  style = {},
}) => {
  const { tools } = drawSpaceConfig;

  const buttonBase = {
    padding: "4px 8px",
    fontFamily: theme.typography.button.fontFamily,
    fontSize: theme.typography.button.fontSize,
    fontWeight: theme.typography.button.fontWeight,
    borderRadius: theme.borders.radius.md,
    border: `1px solid ${theme.colors.borders.default}`,
    background: theme.colors.background.surface,
    color: theme.colors.text.body,
    cursor: "pointer",
    whiteSpace: "nowrap",
    height: 28,
  };

  const activeButton = {
    background: theme.Generic.blue.selected.bg,
    color: theme.Generic.blue.selected.text,
  };

  const renderTool = (label, value) => {
    const active = tool === value;

    return (
      <button
        key={value}
        onClick={() => setTool(value)}
        style={{
          ...buttonBase,
          ...(active ? activeButton : {}),
        }}
      >
        {label}
      </button>
    );
  };

  return (
    <div
      style={{
        display: "flex",
        gap: theme.spacing.sm,
        padding: theme.spacing.sm,
        borderBottom: `1px solid ${theme.colors.borders.panel}`,
        background: theme.colors.background.surface,
        alignItems: "center",
        flexWrap: "wrap",
        ...style,
      }}
    >
      {renderTool("Select", tools.SELECT)}
      {renderTool("Area Rect", tools.AREA_RECT)}
      {renderTool("Area Polyline", tools.AREA_POLYLINE)}
      {renderTool("Line", tools.LINE)}
      {renderTool("Circle", tools.CIRCLE)}
      {renderTool("Move", tools.MOVE)}
      {renderTool("Copy", tools.COPY)}
      {renderTool("Delete", tools.DELETE)}
      {renderTool("Pan", tools.PAN)}

      <button onClick={zoomIn} style={buttonBase}>
        Zoom +
      </button>

      <button onClick={zoomOut} style={buttonBase}>
        Zoom -
      </button>

      <button onClick={resetView} style={buttonBase}>
        Reset
      </button>

      <select
        value={String(gridSize)}
        onChange={(e) => setGridSize(Number(e.target.value))}
        style={{
          ...buttonBase,
          minWidth: 90,
          padding: "0 8px",
        }}
      >
        {drawSpaceConfig.defaults.gridPresets.map((item) => (
          <option key={item.value} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>

      <button
        onClick={() => setSnapToGrid(!snapToGrid)}
        style={{
          ...buttonBase,
          ...(snapToGrid ? activeButton : {}),
        }}
      >
        Snap
      </button>

      {enablePrint && (
        <button onClick={onPrint} style={buttonBase}>
          Print
        </button>
      )}
    </div>
  );
};

export default DrawToolbar;